import React from 'react';
import { ApolloProvider } from 'react-apollo';

export const withApolloProvider = Comp => props => (
  <ApolloProvider client={window.__WINGS_CLIENT__}>
    <Comp {...props} />
  </ApolloProvider>
);
